<template>
	<div
		class="c-global-basket__total-container"
		v-if="basket"
		:class="{ 'c-global-basket__total-container-visible': basket && !basket.isEmpty }"
	>
		<dl class="ds-datalist ds-datalist--side-by-side">
			<template v-if="!basket.isReimbursableOnly">
				<template v-if="basket.formattedSubTotal">
					<dt class="ds-datalist__title">{{ labels.subTotalLabel }}</dt>
					<dd class="ds-datalist__text ds-datalist--nums">{{ basket.formattedSubTotal }}</dd>
				</template>

				<template v-if="basket.isCouponApplied">
					<dt class="ds-datalist__title">
						{{ labels.couponDiscountTotalLabel }}
						<span
							v-if="basket.appliedCouponCode"
							class="c-global-basket__applied-discount"
						>
							({{ basket.appliedCouponCode }})
						</span>
					</dt>
					<dd class="ds-datalist__text ds-datalist--nums">
						-{{ basket.formattedDiscountTotal }}
					</dd>
				</template>
				<template v-if="!basket.marketSpecificTax && basket.formattedSalesTaxTotal && basketContainsNonSampleItems">
					<dt class="ds-datalist__title">{{ labels.salesTaxTotalLabel }}</dt>
					<dd class="ds-datalist__text ds-datalist--nums">
						<template v-if="e1TaxSettings.IsE1TaxCalculationEnabled">
							<InlineSpinner v-if="e1TaxCalculate.isE1TaxLoading"/>
							<template v-else>
								{{ e1TaxAmountLabel }}
							</template>
						</template>
						<template v-else>
							{{ basket.formattedSalesTaxTotal }}
						</template>
					</dd>
				</template>
			</template>

			<dt class="ds-datalist__title">
				{{ labels.shippingLabel }}
				<DsToggletip v-if="labels.shippingInformationTooltip"
					:aria-label="labels.shippingInformationTooltip"
					:text="labels.shippingInformationTooltip"
					iconSize="sm"
					placement="right-start"
					class=""
					/>
			</dt>
			<dd class="ds-datalist__text ds-datalist--nums">
				{{ basket.shippingTotal > 0 ? basket.formattedShippingTotal : labels.freeShippingLabel }}
			</dd>

			<template v-if="basket.marketSpecificTax && basketContainsNonSampleItems">
				<dt class="ds-datalist__title">{{ labels.vatAmountLabel }}</dt>
				<dd class="ds-datalist__text ds-datalist--nums">
					<template v-if="e1TaxSettings.IsE1TaxCalculationEnabled">
						<InlineSpinner v-if="e1TaxCalculate.isE1TaxLoading"/>
						<template v-else>
							{{ e1TaxAmountLabel }}
						</template>

					</template>

					<template v-else>
						{{ basket.formattedTaxTotal }}
					</template>

				</dd>
			</template>

			<template v-if="!hideTotalPrice">
				<dt class="ds-datalist__title">
					<DsText text-type="body-lg" text-style="bold" htmlElement="span">{{ labels.totalLabel }}</DsText>
				</dt>
				<dd class="ds-datalist__text ds-datalist--nums">
					<DsText text-type="body-lg" text-style="bold" htmlElement="span">
						<template v-if="e1TaxSettings.IsE1TaxCalculationEnabled">
							<InlineSpinner v-if="e1TaxCalculate.isE1TaxLoading"/>
							<template v-else>
								{{ e1TotalInclTax }}
							</template>
						</template>
						<template v-else>
							{{ basket.formattedTotal }}
						</template>
					</DsText>
				</dd>
			</template>
		</dl>

		<notification
			:message="basket?.informationMessages?.deliveryFeeInformationMessage.message"
			:iconName="basket?.informationMessages?.deliveryFeeInformationMessage.iconName"
			v-if="basket?.informationMessages?.deliveryFeeInformationMessage.showMessage" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { DsText, DsToggletip } from '@coloplast/design-system';
import InlineSpinner from 'shared/components/inlineSpinner.vue';
import notification from 'shared/components/basket/notification.vue';

export default {
	name: 'fly-out-basket-total',
	props: {
		showTotal: {
			type: Boolean,
			default: false,
		},
		labels: {
			type: Object,
			required: true,
		},
		hideTotalForReimbursableOnly: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		DsText,
		notification,
		DsToggletip,
		InlineSpinner,
	},
	computed: {
		...mapGetters({
			basket: 'getBasket',
			e1TaxSettings: 'getE1TaxSettings',
			e1TaxCalculate: "getE1TaxCalculate",
		}),
		hideTotalPrice() {
			return !this.showTotal || (this.basket.isReimbursableOnly && this.hideTotalForReimbursableOnly);
		},
		e1TaxAmountLabel() {
			if (this.e1TaxCalculate.taxParams?.showTaxInformationalMessageText) {
				return this.e1TaxSettings.TaxInformationalMessageText;
			} else {
				return this.e1TaxCalculate.taxParams?.tax || this.e1TaxSettings.TaxInformationalMessageText;
			}
		},
		e1TotalInclTax() {
			return this.e1TaxCalculate.taxParams?.price || this.basket.formattedTotal;
		},

		basketContainsNonSampleItems() {
			return this.basket?.paid?.length + this.basket?.reimburseable?.length + this.basket?.outOfPocket?.length > 0;
		},

	}
};
</script>


<style lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.ds-tooltip__target {
	line-height: 1;
	margin-left: ds-space(2);
	color: ds-color("fg", "link");
}
</style>
